import Model from "./Model";
import IVideoTutorial from "./interfaces/IVideoTutorial";

export default class VideoTutorial extends Model implements IVideoTutorial {
  static type = "video_tutorials";

  name: string;
  videos: Array<any>;
}
